/**
 * Enum representing the supported application languages.
 * Used for language selection, translation services, and localization.
 */
export enum Language {
  English = "english",
  Dutch = "dutch",
  French = "french",
  German = "german"
}
